<template>
  <div class="help-item">
    <span v-if="hasIconOrPlaceholder"
          class="help-item__icon">
      <i v-if="useStandardIcon"
         :class="iconClass"
         aria-hidden="true">
      </i>
      <picture v-else>
        <source :srcset="customIcon.url">
        <img class="help-item__customIcon"
             :width="customIcon.width"
             :height="customIcon.height"
             :src="`${customIcon.url}?format='*'`"
             :alt="customIcon.alt">
      </picture>
    </span>
    <h3 class="help-item__heading">
      <a v-if="isValidLink"
         class="help-item__heading-link"
         :target="link.target"
         :title="heading"
         :href="link.url">
        {{ heading }}
      </a>
      <template v-else>
        {{ heading }}
      </template>
    </h3>
    <p class="help-item__description">
      {{ description }}
    </p>
    <div v-if="isValidLink"
         class="help-item__action">
      <a
        class="gl-link"
        :target="link.target"
        :href="link.url"
        rel="nofollow">
        Read more
        <font-awesome-icon
          :icon="['fal', 'chevron-right']"
          aria-hidden="true">
        </font-awesome-icon>
      </a>
    </div>
  </div>
</template>
<script>

export default {
  name: "HelpItemCard",
  props: {
    customIcon: {
      type: Object,
      default: () => ( null ),
      validator: ( val ) => ["url", "alt", "width", "height", "name"].every( key => key in val ), // todo: add image obj keys
    },
    link: {
      type: Object,
      default: () => ( undefined ),
      validator: ( val ) => ( ["name", "url", "target"].every( ( key ) => key in val ) ),
    },
    heading: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasCustomIcon () {
      return this.customIcon && ["name", "url"].every( ( key ) => !!this.customIcon[key] );
    },
    isCustomIconPlaceholder () {
      return !this.hasCustomIcon && this.customIcon && this.customIcon.url;
    },
    hasIcon () {
      return !!this.iconClass;
    },
    hasIconOrPlaceholder () {
      return this.hasIcon || this.hasCustomIcon || this.isCustomIconPlaceholder;
    },
    useStandardIcon () {
      return !this.hasCustomIcon && this.hasIcon; // else placeholder
    },
    isValidLink () {
      return this.link && this.link.url;
    },
  },
};

</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.help-item {
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.875rem 3.75rem;

  &__icon {
    font-size: 4rem;
    color: @color-accent-1;
  }

  &__customIcon {
    width: auto;
    max-height: 1em;
  }

  &__heading {
    margin-bottom: 0.9375rem;
    font-size: 1.5rem;

    &-link {
      text-decoration: none;
      color: #333;

      &:hover {
        text-decoration: none;
        color: #333;
      }
    }
  }

  &__description {
    flex-grow: 1;
    font-size: 1rem;
  }

  &__action {
    font-weight: 500;

    > a {
      font-size: 0.88rem;
    }
  }
}
</style>
